// extracted by mini-css-extract-plugin
export var actions = "_6m-8";
export var arrow = "_6m-5";
export var card = "_6m-0";
export var cardWrapper = "_6m-9";
export var fieldName = "_6m-3";
export var newValue = "_6m-6";
export var oldValue = "_6m-4";
export var orangeGlowFade = "_6m-c";
export var productSection = "_6m-1";
export var scrollToBottom = "_6m-b";
export var scrollToBottomAnchor = "_6m-a";
export var scrollToBottomIcon = "_6m-d";
export var showAllButton = "_6m-7";
export var table = "_6m-2";